module.exports = __webpack_public_path__ + "img/hover-dy.90dc5762.png";